import { API } from "./api";

export const getRestaurantsByOwner = (ownerId) =>
  API.get(`/restaurants/owner/${ownerId}`);
export const addRestaurants = (restaurants) =>
  API.post(`/restaurants`, restaurants);

export const deleteRestaurants = (restaurantsId) =>
  API.delete(`/restaurants/${restaurantsId}`);

export const updateRestaurants = (id, restaurants) =>
  API.put(`restaurants/${id}`, restaurants);
export const getRestaurantById = (id) => API.get(`/restaurants/${id}`);
export const getAllRestaurants = () => API.get(`/restaurants`);

export const getRestaurantsWithScreens = (startDate, numberOfWeeks, location) =>
  API.post(`/restaurants/getRestaurantsWithScreens`, {
    startDate,
    numberOfWeeks,
    location,
  });
export const getAllRestaurantsWithScreens = (startDate, numberOfWeeks) =>
  API.post(`/restaurants/getAllRestaurantsWithScreens`, {
    startDate,
    numberOfWeeks,
  });
